<template>
  <div class="CDeviceComponent ExpCDeviceComponent" v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
    <div class="tit">设备类型</div>
    <el-tabs v-model="tabActive" @tab-click="tabClick">
      <el-tab-pane label="智慧空间" name="1" v-if="zhkjList.length != 0">
        <p class="no-device" v-if="zhkjList.length == 0 && pageCount == 0">暂无设备</p>
        <swiper :options="swiperOption" ref="mySwiper1" v-else>
          <!-- slides -->
          <swiper-slide v-for="(item,index) in pageCount" :key="index" class="flex">
            <div class="item" v-for="(zhkj,index2) in zhkjList[index]" :key="index2" @click="changeActive(zhkj.code)" :class="{active:zhkj.code==isActive}">
              <template v-if="zhkj.code">
              <div class="img" v-if="zhkj.code == 'ACCESS'"><img src="../../../../static/images/icon/icon_8.png" alt=""></div>
              <div class="img" v-if="zhkj.code == 'ELECTRICMETER'"><img src="../../../../static/images/icon/icon_11.png" alt=""></div>
              <div class="img" v-if="zhkj.code == 'TURN'"><img src="../../../../static/images/icon/icon_13.png" alt=""></div>
              <div class="img" v-if="zhkj.code == 'MAGICCUBE'"><img src="../../../../static/images/icon/icon_9.png" alt=""></div>
              <div class="img" v-if="zhkj.code == 'EXPRESS'"><img src="../../../../static/images/icon/icon_2.png" alt=""></div>
              <div class="img" v-if="zhkj.code == 'WAREHOUSE'"><img src="../../../../static/images/icon/icon_5.png" alt=""></div>
              <div class="img" v-if="zhkj.code == 'INVENTORYROBOT'"><img src="../../../../static/images/icon/icon_3.png" alt=""></div>
              <div class="img" v-if="zhkj.code == 'TOOL'"><img src="../../../../static/images/icon/icon_14.png" alt=""></div>
              <div class="img" v-if="zhkj.code == 'ESTAND'"><img src="../../../../static/images/icon/icon_1.png" alt=""></div>
              <div class="img" v-if="zhkj.code == 'EPSENSOR'"><img src="../../../../static/images/icon/icon_16.png" alt=""></div>
              <div class="img" v-if="zhkj.code == 'MULTIWAREHOUSE'"><img src="../../../../static/images/icon/icon_18.png" alt=""></div>
              <div class="img" v-if="zhkj.code == 'NODOORWAREHOUSE'"><img src="../../../../static/images/icon/icon_15.png" alt=""></div>
              <div class="img" v-if="zhkj.code == 'MULTIRESTAND'"><img src="../../../../static/images/icon/icon_17.png" alt=""></div>
              <div class="img" v-if="zhkj.code == 'DEPOSIT'"><img src="../../../../static/images/icon/icon_19.png" alt=""></div>
              <div class="img" v-if="zhkj.code == 'MEDITOOL'"><img src="../../../../static/images/icon/icon_20.png" alt=""></div>
              <div class="img" v-if="zhkj.code == 'IOTLETTERBOX'"><img src="../../../../static/images/icon/icon_6.png" alt=""></div>
              <div class="img" v-if="zhkj.code == 'SOCKET'"><img src="../../../../static/images/icon/icon_10.png" alt=""></div>
              <div class="img" v-if="zhkj.code == 'WATERMETER'"><img src="../../../../static/images/icon/icon_12.png" alt=""></div>
              <div class="img" v-if="zhkj.code == 'SAFEEXPRESS'"></div>
              <div class="img" v-if="zhkj.code == 'KEYBOX'"><img src="../../../../static/images/icon/icon_22.png" alt=""></div>
              </template>
              <div class="name">{{zhkj.name}}</div>
            </div>
          </swiper-slide>
          <!-- Optional controls -->
          <div class="swiper-pagination"  slot="pagination"></div>
          <div class="el-icon-caret-left" slot="button-prev"></div>
          <div class="el-icon-caret-right" slot="button-next"></div>
        </swiper>
      </el-tab-pane>
      <el-tab-pane label="智慧供应链" name="2">
        <p class="no-device" v-if="zhgylList.length == 0 && pageCount2 == 0">暂无设备</p>
        <swiper :options="swiperOption" ref="mySwiper2" v-else>
          <!-- slides -->
          <swiper-slide v-for="(item,index) in pageCount2" :key="index" class="flex">
            <div class="item" v-for="(zhgyl,index2) in zhgylList[index]" :key="index2" @click="changeActive(zhgyl.code)" :class="{active:zhgyl.code==isActive}">
              <template v-if="zhgyl.code">
              <div class="img" v-if="zhgyl.code == 'WAREHOUSE'"><img src="../../../../static/images/icon/icon_5.png" alt=""></div>
              <div class="img" v-if="zhgyl.code == 'INVENTORYROBOT'"><img src="../../../../static/images/icon/icon_3.png" alt=""></div>
              <div class="img" v-if="zhgyl.code == 'TOOL'"><img src="../../../../static/images/icon/icon_14.png" alt=""></div>
              <div class="img" v-if="zhgyl.code == 'ACCESS'"><img src="../../../../static/images/icon/icon_8.png" alt=""></div>
              <div class="img" v-if="zhgyl.code == 'ELECTRICMETER'"><img src="../../../../static/images/icon/icon_11.png" alt=""></div>
              <div class="img" v-if="zhgyl.code == 'TURN'"><img src="../../../../static/images/icon/icon_13.png" alt=""></div>
              <div class="img" v-if="zhgyl.code == 'MAGICCUBE'"><img src="../../../../static/images/icon/icon_9.png" alt=""></div>
              <div class="img" v-if="zhgyl.code == 'EXPRESS'"><img src="../../../../static/images/icon/icon_2.png" alt=""></div>
              <div class="img" v-if="zhgyl.code == 'ESTAND'"><img src="../../../../static/images/icon/icon_1.png" alt=""></div>
              <div class="img" v-if="zhgyl.code == 'EPSENSOR'"><img src="../../../../static/images/icon/icon_16.png" alt=""></div>
              <div class="img" v-if="zhgyl.code == 'MULTIWAREHOUSE'"><img src="../../../../static/images/icon/icon_18.png" alt=""></div>
              <div class="img" v-if="zhgyl.code == 'NODOORWAREHOUSE'"><img src="../../../../static/images/icon/icon_15.png" alt=""></div>
              <div class="img" v-if="zhgyl.code == 'MULTIRESTAND'"><img src="../../../../static/images/icon/icon_17.png" alt=""></div>
              <div class="img" v-if="zhgyl.code == 'DEPOSIT'"><img src="../../../../static/images/icon/icon_19.png" alt=""></div>
              <div class="img" v-if="zhgyl.code == 'MEDITOOL'"><img src="../../../../static/images/icon/icon_20.png" alt=""></div>
              <div class="img" v-if="zhgyl.code == 'IOTLETTERBOX'"><img src="../../../../static/images/icon/icon_6.png" alt=""></div>
              <div class="img" v-if="zhgyl.code == 'SOCKET'"><img src="../../../../static/images/icon/icon_10.png" alt=""></div>
              <div class="img" v-if="zhgyl.code == 'WATERMETER'"><img src="../../../../static/images/icon/icon_12.png" alt=""></div>
              <div class="img" v-if="zhgyl.code == 'SAFEEXPRESS'"></div>
              <div class="img" v-if="zhgyl.code == 'KEYBOX'"><img src="../../../../static/images/icon/icon_22.png" alt=""></div>
              </template>
              <div class="name" :title="zhgyl.name">{{zhgyl.name}}</div>
            </div>
          </swiper-slide>
          <!-- Optional controls -->
          <div class="swiper-pagination"  slot="pagination"></div>
          <div class="el-icon-caret-left" slot="button-prev"></div>
          <div class="el-icon-caret-right" slot="button-next"></div>
        </swiper>
      </el-tab-pane>
    </el-tabs>
    <div class="tit bgd2">设备列表</div>
    <div class="listCont mg20" v-loading="dioLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <div class="contBtn mb20" v-if="isActive == 'ELECTRICMETER'">
        <el-button type="primary" @click="isEcharts = false" v-if="isEcharts == true">查看详情</el-button>
        <el-button type="primary" @click="isEcharts = true" v-else>查看总览</el-button>
      </div>
      <template v-if="isEcharts == false">
      <p class="no-device" v-if="deviceList.length == 0">暂无设备</p>
      <div class="list" v-else>
        <div class="li" v-for="(item,index) in deviceList" :key="index">
          <div class="liCont">
            <div class="name">
              <span :title="item.device_name">{{item.device_name}}</span>
              <i v-if="item.online == false">离线</i>
              <i v-if="item.online == true" class="onLine">在线</i>
            </div>
            <div class="tip">{{item.device_no_id}}</div>
            <div class="bot">
              <div class="detail" @click="openDetail(index, 'detail')" 
                v-if="isActive!='ACCESS'&&
                isActive!='INVENTORYROBOT'&&
                isActive!='NODOORWAREHOUSE'&&
                isActive!='MULTIWAREHOUSE'&&
                isActive!='WAREHOUSE'&&
                isActive!='SOCKET'">详情</div>
              <div v-if="item.type=='2' && isActive == 'ACCESS'" class="detail" @click="openDetail(index)">开门记录</div>
              <!-- 保密柜显示 -->
              <div v-if="item.type=='1' && isActive == 'SAFEEXPRESS'" class="detail" @click="openDetail(index, 'address')">当前位置</div>
            </div>
          </div>
          <div>
            <template v-if="item.type == '1'">
              <el-button size="mini" disabled v-if="item.online == false">重启</el-button>
              <!-- <el-button class="restart" size="mini" v-else @click="deviceControl(index)">重启</el-button> -->
              <el-button class="restart" size="mini" v-else @click="deviceControl(index)">重启</el-button>
            </template>
            <template v-else-if="item.type=='2' && isActive == 'ACCESS'">
              <el-button size="mini" disabled v-if="item.online == false">开门</el-button>
              <el-button class="restart" size="mini" v-else @click="deviceControl(index)">开门</el-button>
            </template>
            <template v-else-if="isActive=='ELECTRICMETER' || isActive=='SOCKET'">
              <el-switch
                v-model="item.isOpen"
                active-color="#13ce66"
                inactive-color="#d2d2d2"
                :width="widthNum"
                active-value="1"
                inactive-value="2"
                active-text="on"
                inactive-text="off"
                @change="deviceControl(index)">
              </el-switch>
            </template>
          </div>
          <div class="ewm" v-if="item.type=='2' && isActive == 'ACCESS'" @click="previewImg(index)"></div>
        </div>
      </div>
      </template>
      <template v-else>
        <!--电表的统计图-->
        <!-- <cammentermanage></cammentermanage>· -->
      </template>
    </div>

    <!--详情弹窗-->
    <el-dialog :title="detailTit" :visible.sync="detailDio" width="795px" class="detailDio">
      <div class="contDio" v-if="deviceType == '1' && dtype == 'detail'">
        <div class="tit_dio">
          <div class="flexItem">设备名称：{{wareInfo.device_name}}</div>
          <div class="flexItem">设备ID：{{wareInfo.device_no_id}}</div>
          <div class="flexItem">箱格数量：{{wareInfo.total}}</div>
        </div>
        <div class="list_dio">
          <el-row :gutter="19">
            <el-col :span="4" v-for="(item,index) in boxList" :key="index">
              <div class="colItem">
                <div class="name">
                  <template>{{item.box_number}}</template>
                  <template v-if="item.box_size == 'A'">(极大)</template>
                  <template v-if="item.box_size == 'B'">(大)</template>
                  <template v-if="item.box_size == 'C'">(中)</template>
                  <template v-if="item.box_size == 'D'">(小)</template>
                  <template v-if="item.box_size == 'E'">(极小)</template>
                </div>
                <div class="tip1">
                  <span v-if="item.status=='0'">空闲中</span>
                  <span v-if="item.status=='1'" class="isIng">使用中</span>
                  <span v-if="item.status=='-1'" class="isNo">已禁用</span>
                </div>
                <div class="tip2">
                  <span v-if="item.openStatus == 'off'">已关闭</span>
                  <span v-if="item.openStatus == 'on'" class="isOpen">已打开</span>
                </div>
                <div class="btn" v-loading="item.isLoading">
                  <em class="noBtn" v-if="item.status=='-1'||wareInfo.online == false">打开</em>
                  <em v-else @click="boxControl(index)">打开</em>
                </div>
              </div>
            </el-col>
          </el-row>
          <div class="paging" v-if="total>page">
            <el-pagination
              background
              @current-change="CurrentChange"
              :current-page.sync="curr"
              :page-size="page"
              layout="prev, pager, next"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
      <div class="contDio" v-if="deviceType == '3'">
        <div class="meterList">
          <div class="meterStatus">
            <div class="item_meter"><span>设备名称：</span><p>{{wareInfo.device_name}}</p></div>
            <div class="item_meter"><span>设备ID：</span><p>{{wareInfo.device_no_id}}</p></div>
            <div class="item_meter"><span>当前状态：</span><p v-if="wareInfo.online == true">在线</p><p v-else>离线</p></div>
            <div class="item_meter"><span>当前读数：</span><p>{{wareInfo.deviceEmeter}}kwh</p></div>
          </div>
          <div class="echartsDiv">
            <div class="time">
              <el-radio-group v-model="timeType" size="mini" @change="getEmeterYearMonthDay(wareInfo.index)">
                <el-radio label="YEAR" border>年</el-radio>
                <el-radio label="MONTH" border>月</el-radio>
                <el-radio label="DAY" border>日</el-radio>
              </el-radio-group>
            </div>
            <div class="echart" id="echartDetail"></div>
          </div>
        </div>
      </div>
      <div class="contDio" v-if="deviceType == '2' && isActive == 'ACCESS'">
        <div class="tit_dio">
          <div class="flexItem">设备名称：{{wareInfo.device_name}}</div>
          <div class="flexItem">设备ID：{{wareInfo.device_no_id}}</div>
          <div class="item_meter">状态：<span v-if="wareInfo.online == true">在线</span><span v-else>离线</span></div>
        </div>
        <el-table style="width:100%;" :data="accessList">
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column label="操作人" prop="user_name"></el-table-column>
          <el-table-column label="类型">
            <template slot-scope="scope">
              <span v-if="scope.row.open_type=='OPEN_KEY'">远程开门</span>
              <span v-else-if="scope.row.open_type=='SHARE_OPEN_KEY'">权限分享</span>
              <span v-else-if="scope.row.open_type=='SCANNED_OPEN'||scope.row.open_type=='SCAN_OPEN'">扫码开门</span>
              <span v-else-if="scope.row.open_type=='CARD_OPEN'">刷卡开门</span>
              <span v-else-if="scope.row.open_type=='FACE_OPEN'">人脸开门</span>
              <span v-else>按钮开门</span>
            </template>
          </el-table-column>
          <el-table-column label="开门时间" prop="open_time"></el-table-column>
        </el-table>
        <div class="paging" v-if="total2>page2">
          <el-pagination
            background
            @current-change="CurrentChange2"
            :current-page.sync="curr2"
            :page-size="page2"
            layout="prev, pager, next"
            :total="total2">
          </el-pagination>
        </div>
      </div>
      <div class="contDio" v-if="deviceType == '1' && isActive == 'SAFEEXPRESS' && dtype == 'address'">
        <CDeviceMap :device_no_id="wareInfo.device_no_id" @getActiveInfo="getActiveInfo"></CDeviceMap>
      </div>
    </el-dialog>

    <!--查看二维码-->
    <el-dialog title="" :visible.sync="previewDio" class="previewDio" width="350px">
      <div class="tr"><el-button v-print="'#ewm'">打印</el-button></div>
      <div class="img" id="ewm"><img :src="dioImageUrl" alt=""></div>
      <!-- <div class="img" id="ewm">测试打印</div> -->
      <div class="tips">此二维码用于门禁开门，授权用户<br>扫描后可立即进行开门操作</div>
    </el-dialog>

  </div>
</template>

<script>
  // import cammentermanage from "../CEnergyManage/CAmmeterManage"
  import CDeviceMap from './CDeviceMap.vue'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import { showLoading, hideLoading, showToast, updataBreadCrumb, localUserInfo } from "../../../../static/js/utility/utility.js"
  import * as expConfig from "../../../../static/js/exp/config.js"
  import { expSceneApi } from "../../../../static/js/exp/scene.js"
  let vm
  
  export default {
    name: 'ExpCDeviceComponent',
    props:{
    },
    data() {
      return {
        tabActive:'2',
        
        space_id:[],//空间id

        pageCount:0,
        zhkjList:[],//智慧空间
        
        pageCount2: 0,
        zhgylList: [],//智慧供应链

        isActive: 'WAREHOUSE',

        swiperOption: {
          navigation: {
            nextEl: '.el-icon-caret-left',
            prevEl: '.el-icon-caret-right',
          },
          pagination: {
            el: '.swiper-pagination',
            dynamicBullets:true,
          },
          observer:true, 
        },

        deviceList:[],//设备列表

        widthNum:64,

        isEcharts:false,//电表显示总览/详情

        detailTit:'',
        deviceType:'',
        detailDio:false,//详情弹窗
        //柜体详情箱格分页
        curr:1,//当前页
        page:12,//显示个数
        total:20,//总数据

        dioLoading:false,//箱格列表loading
        
        accessList:[],
        //门禁详情箱格分页
        curr2:1,//当前页
        page2:10,//显示个数
        total2:10,//总数据


        timeType:'YEAR',
        xAxisData:[],
        yAxisData:[],
        trendName:'',
        wareInfo:{
          index:0,
          device_no_id:'',
          device_name:'',
          online:false,
          deviceEmeter:'',
          total:0,
        },
        boxList:[],
        isLoading:false,

        previewDio:false,//预览二维码
        dioImageUrl:'',//二维码地址

        dtype: '', // 对话框显示类型
      };
    },
    //定义这个sweiper对象  
    computed: {
    },
    components:{
      swiper,
      swiperSlide,
      // cammentermanage,
      CDeviceMap
    },
    created: async function (){
      // this.space_id = this.$store.state.spaceID
      vm = this
      this.getEquipment()
    },
    methods:{
      //通过设备类型获取设备列表
      async getEquipmentDeviceList(code){
        let that = this
        this.deviceList=[]
        let data = {
          code:code
        }
        let res = await expSceneApi.getEquipmentDeviceList(data)
        console.log('res', res)
        let list = res.data
          for(let i in list){
            if(list[i].openStatus == 'on'){
              list[i].isOpen = '1'
            }else{
              list[i].isOpen = '2'
            }
          }
          that.deviceList = list
      },
      //业务单选
      changeActive(code,type){
        this.isActive = code
        this.getEquipmentDeviceList(code)
        if(code != 'ELECTRICMETER'){
          this.isEcharts = false;
        }
      },
      //获取设备类型列表
      async getEquipment(){
        let that = this;
        let data = expConfig.equipmentData.typeList
        var arrList = data.ZHKJ
          var arrList2 = data.ZHGYL
          var limits = 7;//每页显示条数
          if(arrList!=''){
            that.isActive = arrList[0].code
            that.tabActive = '1'
            that.getEquipmentDeviceList(that.isActive)
          }else if(arrList2!='' && arrList==''){
            that.isActive = arrList2[0].code
            that.tabActive = '2'
            that.getEquipmentDeviceList(that.isActive)
          }else{
            that.isActive = ''
            that.tabActive = '1'
            that.deviceList=[]
          }
          
          if(arrList!=''){
            that.pageCount = Math.ceil(arrList.length/limits)
            var arr = []
            for(var i = 0, j = arrList.length; i < j; i += limits){
              arr.push(arrList.slice(i,i+limits))
            }
            that.zhkjList = arr
          }else{
            that.zhkjList=[]
            that.pageCount=0
          }
          if(arrList2!=''){
            var limits2 = 7;//每页显示条数
            that.pageCount2 = Math.ceil(arrList2.length/limits2)
            var arr2 = []
            for(var i = 0, j = arrList2.length; i < j; i += limits2){
              arr2.push(arrList2.slice(i,i+limits2))
            }
            that.zhgylList = arr2
          }else{
            that.zhgylList=[]
            that.pageCount2=0
          }

          if(that.isActive != 'ELECTRICMETER'){
            this.isEcharts = false;
          }
      },
      // tab切换点击
      tabClick(tab, event) {
        let that = this
        if(this.tabActive=='1'){
          if(that.zhkjList[0]){
            that.isActive = that.zhkjList[0][0].code
            that.getEquipmentDeviceList(this.isActive)
          }else{
            that.isActive = ''
            that.deviceList = []
          }
        }else{
          if(that.zhgylList[0]){
            that.isActive = that.zhgylList[0][0].code
            that.getEquipmentDeviceList(that.isActive)
          }else{
            that.isActive = ''
            that.deviceList = []
          }
        }
      },
      //设备开关询问
      deviceControl(index){
        let that = this;
        let cfTitle = '', lText = ''
        if(that.deviceList[index].type == '1'){
          cfTitle = '你确定要重启？'
          lText = '正在重启中'
        }else if(that.deviceList[index].type == '2' && that.isActive == 'ACCESS'){
          cfTitle = '你确定要开门？'
          lText = '正在开门中'
        }else if(that.isActive=='ELECTRICMETER' || that.isActive=='SOCKET'){
          if(that.deviceList[index].isOpen == '2'){
            cfTitle = '你确定要关闭？'
          lText = '正在关闭中'
          }else{
            cfTitle = '你确定要开启？'
          lText = '正在开启中'
          }
        }
        this.$confirm(cfTitle, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          console.log('tag', lText)
          showLoading(lText)
          setTimeout(() => {
            that.deviceControlFun(index)
          }, 1000)
        }).catch(() => {
          if(that.isActive=='ELECTRICMETER' || that.isActive=='SOCKET'){
            if(that.deviceList[index].isOpen == '1'){
              that.deviceList[index].isOpen = '2'
            }else{
              that.deviceList[index].isOpen = '1'
            }
          }
        });
      },
      //设备开关
      async deviceControlFun(index){
        hideLoading()
        let that = this;
        let switchType=''
        if(that.deviceList[index].type=='1'){
          switchType = 'reboot'
        }else{
          if(that.isActive=='ACCESS'){
            switchType = 'open'
          }else{
            if(that.deviceList[index].isOpen == '1'){
              switchType = 'open'
            }else{
              switchType = 'close'
            }
          }
        }
        const dataObj = {
          'type':switchType,
          'device_no_id': that.deviceList[index].device_no_id
        }
        const res = {
          meta: {
            code: 200,
            message: '成功'
          },
          data: {
            result: true
          }
        }
        if(res.meta.code == 200){
          if(res.data.result == true){
            if(that.deviceList[index].type == '1'){
              showToast('重启成功！')
            }
            if(that.deviceList[index].type == '2' && that.isActive == 'ACCESS'){
              showToast('打开成功！')
            }
            if(that.isActive=='ELECTRICMETER' || that.isActive=='SOCKET'){
              if(that.deviceList[index].isOpen == '1'){
                showToast('已开启')
              }else{
                showToast('已关闭！')
              }
            }
          }else{
            if(that.deviceList[index].type == '1'){
              showToast('重启失败！')
            }
            if(that.deviceList[index].type == '2' && that.isActive == 'ACCESS'){
              showToast('开门失败！')
            }
            if(that.isActive=='ELECTRICMETER' || that.isActive=='SOCKET'){
              if(that.deviceList[index].isOpen == '1'){
                showToast('开启失败！')
                that.deviceList[index].isOpen = '2'
              }else{
                showToast('关闭失败！')
                that.deviceList[index].isOpen = '1'
              }
            }
          }
          that.getEquipmentDeviceList(that.isActive)
        }else{
          if(that.isActive=='ELECTRICMETER' || that.isActive=='SOCKET'){
            if(that.deviceList[index].isOpen == '1'){
              that.deviceList[index].isOpen = '2'
            }else{
              that.deviceList[index].isOpen = '1'
            }
          }
          showToast(res.meta.message)
        }
      },
      //打开详情
      openDetail(index, dtype){
        let that = this;
        that.dtype = dtype
        that.deviceType = that.deviceList[index].type
        that.wareInfo.index = index
        that.wareInfo.device_no_id = that.deviceList[index].device_no_id
        that.wareInfo.device_name = that.deviceList[index].device_name
        that.wareInfo.online = that.deviceList[index].online
        if(this.deviceList[index].type =='1' && dtype == 'detail'){
          that.detailTit='查看箱格'
          that.curr=1;
          that.total=0;
          that.getDeviceBoxList(this.wareInfo.index,that.curr,that.page)
        }
        if(this.deviceList[index].type =='2' && this.isActive == 'ACCESS'){
          that.detailTit='开门记录'
          that.curr2=1;
          that.total2=0;
          that.deviceRecord(index)
        }
        if(this.deviceList[index].type =='3' && this.isActive == 'ELECTRICMETER'){
          that.detailTit='查看电表数据'
          that.getEmeterYearMonthDay(index)
        }
        if(this.deviceList[index].type =='1' && this.isActive == 'SAFEEXPRESS' && dtype == 'address'){
          that.detailDio = true
        }
      },
      //获取箱格列表
      async getDeviceBoxList(index,curr,limits,type){
        let that = this;
        if(!type){
          this.dioLoading = true
        }

        let list = expConfig.equipmentData.deviceBoxList
          for(let i in list){
            list[i].isLoading = false
          }
          // that.total = parseInt(total)
          that.wareInfo.total = list.length
          that.boxList = list
          if(!type){
            that.dioLoading = false
            that.detailDio = true
          }
      },
      //询问箱格开关
      boxControl(index){
        let that = this;
        this.$confirm('你确定要打开箱门？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.boxControlFun(index)
        }).catch(() => {});
      },
      //箱格开关
      async boxControlFun(index){
        let that = this;
        that.boxList[index].isLoading = true
        const dataObj = {
          'type':'open',
          'device_no_id': that.boxList[index].device_no_id,
          'box_no': that.boxList[index].box_number
        }
        const res = {
          meta: {
            code: 200,
            message: '成功'
          },
          data: {
            result: true
          }
        }
        setTimeout(() => {
          if(res.meta.code == 200){
            that.boxList[index].isLoading = false
            if(res.data.result ==true){
              showToast('箱格打开成功')
              // that.$message.success('箱格打开成功')
            }else{
              showToast('箱格打开失败')
              // that.$message.error('箱格打开失败')
            }
            that.getDeviceBoxList(this.wareInfo.index,that.curr,that.page,'detail')
          }else{
            showToast(res.meta.message)
            // that.$message.error(res.meta.message)
          }
        }, 1000);
      },


      // 保密柜-获取当前选中保密柜信息
      getActiveInfo (space_name){
        this.detailTit = space_name
      },
      //查看门禁二维码
      async previewImg(index){
        let that = this;
        let company_ic = localUserInfo.getItem().company_ic
        const dataObj = {
          data:{
            "page": "pages/login/login",
            "scene": company_ic+"so"+that.deviceList[index].device_no_id
          },
          mode: "getUnlimited",
          type: "so",
          device_no_id: that.deviceList[index].device_no_id
        }
        const res = await deviceApi.previewImg(dataObj)
        if (res.meta.code === 200) {
          that.dioImageUrl = res.data.image_url
          that.previewDio = true
        } else {
          showToast(res.meta.message)
        }
      },

      
      //分页
      CurrentChange(val) {
        this.curr = val
        this.getDeviceBoxList(this.wareInfo.index,val,this.page,'detail')
      },
      CurrentChange2(val) {
        this.curr2 = val
        this.deviceRecord(this.wareInfo.index,val,this.page2)
      },
      //获取开门记录
      async deviceRecord(index,curr,limits){
        let that = this;
        this.dioLoading = true
        const dataObj = {
          'device_no_id': that.deviceList[index].device_no_id,
          'page':curr?curr:that.curr2,
          'perPage': limits?limits:that.page2,
        }
        const res = await deviceApi.deviceRecord(dataObj)
        if(res.meta.code == 200){
          that.accessList = res.data.list
          that.total2 = parseInt(res.data.count)
          that.dioLoading = false
          that.detailDio = true
        }else{
          that.dioLoading = false
          showToast(res.meta.message)
          // that.$message.error(res.meta.message)
        }
      },

      //获取电表读数
      async getEmeterYearMonthDay(index){
        let that = this
        this.xAxisData=[]
        this.yAxisData=[]
        this.dioLoading = true
        const dataObj ={
          'dateType': that.timeType,
          'device_no_id': that.deviceList[index].device_no_id
        }
        let res = await deviceApi.getEmeterYearMonthDay(dataObj);
        if(res.meta.code == '200'){
          that.wareInfo.deviceEmeter = res.data.deviceEmeter
          for(let i in res.data.list){
            let str =''
            if(that.timeType == 'YEAR'){
              that.trendName = '本年用电量'
              str = i+'月'
            }else if(that.timeType == 'MONTH'){
              that.trendName = '本月用电量'
              str = i+'日'
            }else{
              that.trendName = '今日用电量'
              str = i+'时'
            }
            that.xAxisData.push(str)
            that.yAxisData.push(res.data.list[i])
          }
          that.dioLoading = false
          that.detailDio = true
          this.drawLine(this.xAxisData,this.yAxisData);
        }else{
          that.dioLoading = false
          showToast(res.meta.message)
          // that.$message.error(res.meta.message)
        }
      },
      //电表详情
      drawLine(xAxisData,yAxisData){
        let that = this;
        this.$nextTick(function(){
          // 基于准备好的dom，初始化echarts实例
          let myChart = this.$echarts.init(document.getElementById('echartDetail'))
          // 绘制图表
          let option = {
            title: {
              left: '2%',
              text: that.trendName,
            },
            xAxis: {
              type: 'category',
              data: xAxisData
            },
            yAxis: {
              type: 'value',
              name:'KWH',
            },
            series: [{
              data: yAxisData,
              type: 'line',
              itemStyle : { normal: {label : {show: true}}}
            }]
          };
          // 使用刚指定的配置项和数据显示图表。
          myChart.setOption(option);
        })
      },
    },
    watch:{
      // 监听vuex的值变化
      "$store.state.spaceID":async function(newVal, oldVal) {
        this.space_id = newVal
        // this.tabActive='1'
        this.getEquipment()
      },
    }
  }
</script>

<style lang="scss">
.CDeviceComponent.ExpCDeviceComponent{
  position: relative;
  // height: 100%;
  .previewDio{
    .tr{
      text-align: right;
      el-button{
        display: inline-block;
        line-height: 1;
        padding: 12px 20px;
        border:1px solid #DCDFE6;
        font-size: 14px;
        color: #606266;
        border-radius: 4px;
      }
    }
    .img{
      width: 200px;
      width: 200px;
      margin: 0px auto;
      padding: 20px;
      img{ width:100%; }
    }
    .tips{
      text-align: center;
      color: #F56C6C;
    }
  }
  .noData{
    text-align: center;
    padding:50px 0;
    font-size: 20px;
    color: #999;
  }
  .detailDio{
    .meterList{
      display: flex;
      width: 100%;
      .echartsDiv{
        flex-grow: 1;
        .time{
          text-align: center;
          .el-radio__input{
            display: none;
          }
          .el-radio{
            margin-right: 16px;
            &.is-bordered+.el-radio.is-bordered{
              margin-left: 0px;
            }
          }
        }
        .echart{
          height: 226px;
        }
      }
      .meterStatus{
        width: 180px;
        flex-shrink: 0;
        padding: 15px;
        border-right: 2px solid #dcdcdc;
        box-sizing: border-box;
        .item_meter{
          margin-bottom:15px; 
          span{
            font-size: 12px;
            color: #999;
          }
          p{
            font-size: 16px;
            color: #666;
          }
        }
      }
    }
    .paging{
      margin: 20px 0 15px;
    }
    .list_dio{
      margin: 0 45px;
      .colItem{
        border: 1px solid #c5c5c5;
        border-radius: 5px;
        text-align: center;
        box-shadow: 0 1px 1px 0 rgba(0, 0, 0, .3);
        padding: 5px;
        box-sizing: border-box;
        margin-bottom: 19px;
        .name{
          font-size: 18px;
          color: #333;
          font-weight: bold;
          margin-bottom: 6px;
        }
        .tip1{
          font-size: 12px;
          color: #47ff9d;
          .isIng{
            color: #008cff
          }
          .isNo{
            color: #fd0000
          }
        }
        .tip2{
          font-size: 12px;
          color: #999;
          .isOpen{
            color: #008cff;
          }
        }
        .btn{
          .el-loading-spinner{
            margin-top: -10px;
            .circular{
              width: 20px;
              height: 20px;
            }
          }
          em{
            display: inline-block;
            height: 20px;
            line-height: 20px;
            border-radius: 3px;
            font-size: 12px;
            color: #fff;
            padding: 0 14px;
            background-color: #008cff;
            cursor: pointer;
            &.noBtn{
              background-color: #999;
            }
          }
        }
      }
    }
    .tit_dio{
      font-size: 18px;
      color: #999;
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
    }
    .el-dialog{
      border-radius: 15px;
      overflow: hidden;
      .el-dialog__body{
        padding: 10px 20px;
      }
      .el-dialog__header{
        padding: 16px 18px 18px;
        text-align: center;
        background: #00479d;
        .el-dialog__title{
          color: #fff;
          font-size: 24px;
        }
        .el-dialog__headerbtn{
          font-size: 24px;
          top: 10px;
          .el-dialog__close{
            color: #fff;
          }
        }
      }
    }
    
  }
  .listCont{
    .list{
      display: flex;
      flex-wrap: wrap;
    }
    .li{
      display: flex;
      position: relative;
      width: 303px;
      height: 104px;
      border:1px solid #f0f0f0;
      border-radius: 10px;
      box-shadow: 0 1px 1px 0 rgba(0,0,0,.2);
      box-sizing: border-box;
      padding: 18px 20px;
      align-items: center;
      justify-content: space-between;
      margin-right: 7px;
      margin-bottom:17px;
      font-size: 18px;
      color: #333;
      .ewm{
        position: absolute;
        right: 0px;
        bottom: 0px;
        width: 21px;
        height: 20px;
        background: url('../../../../static/images/icon/icon_ewm.png') no-repeat;
        transition: all .3s;
        &:hover{
          background: url('../../../../static/images/icon/icon_ewm1.png') no-repeat;
        }
      }
      .restart{
        color: #008cff;
        border-color: #008cff;
        padding: 6px 15px;
      }
      .liCont{
        max-width: 70%;
        .bot {
          display: flex;
          .detail+.detail {
            margin-left: 20px;
          }
        }
        .detail{
          font-size: 18px;
          color: #008ef2;
          text-decoration: underline;
        }
        .name{
          display: inline-block;
          align-items: center;
          position: relative;
          padding-right: 45px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          max-width: 100%;
          i{
            position: absolute;
            right: 0px;
            top: 50%;
            margin-top: -10px;
            height: 20px;
            line-height: 20px;
            font-size: 12px;
            padding: 0 6px;
            border-radius: 3px;
            color: #fff;
            background: #e65c67;
            flex-shrink: 0;
            &.onLine{
              background: #40e38c;
            }
          }
        }
      }
    }
    .no-device {
      color: #cccccc;
      text-align: center;
      line-height: 150px;
    }
  }
  .el-switch__label--left{
    position: absolute;
    right: 1px;
    z-index: -1111;
    color: #fff;
  }
  .el-switch__label--right{
    position: absolute;
    left: 1px;
    z-index: -1111;
    color: #fff;
  }
  .el-switch__label.is-active{
    z-index: 1111;
  }
  .el-switch__core{
    height: 28px;
    border-radius: 14px;
    &::after{
      top: 0px;
      width: 26px;
      height: 26px;
    }
  }
  .el-switch.is-checked .el-switch__core::after{
    margin-left: -27px;
  }
  .flex{
    display:flex;
    align-items: center;
    justify-content: center;
  }
  .swiper-container{
    height: 136px;
    .swiper-pagination-bullet{
      width: 10px;
      height: 2px;
    }
    .el-icon-caret-left{
      position: absolute;
      right: 20px;
      top: 50%;
      margin-top: -18px;
      font-size: 36px;
      color: #999;
      z-index: 999;
      transform: rotate(180deg);
      &.swiper-button-disabled{
        opacity:0
      }
      &.swiper-pagination-bullet-active{
        opacity: 1;
      }
    }
    .el-icon-caret-right{
      position: absolute;
      left: 20px;
      top: 50%;
      margin-top: -18px;
      font-size: 36px;
      color: #999;
      z-index: 999;
      transform: rotate(180deg);
      &.swiper-button-disabled{
        opacity:0
      }
      &.swiper-pagination-bullet-active{
        opacity: 1;
      }
    }
    
  }
  .swiper-slide{
    height: 122px;
    width: 100% !important;
    .item{
      text-align: center;
      width: 98px;
      margin: 0 10px;
      .img{
        width: 60px;
        height:60px;
        border-radius: 50%;
        background-color: #cce8ff;
        display:flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
      }
      .name{
        margin-top: 10px;
        font-size: 18px;
        color: #999;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &.active{
        .img{
          box-shadow: 0 2px 3px 0 rgba(11,2,5,.49);
          background-color: #008cff;
        }
        .name{
          color: #0081eb;
        }
      }
    }
  }
  .tit{
    height: 48px;
    line-height: 48px;
    background: #d2d2d2;
    font-size: 24px;
    color:#666;
    padding: 0 20px;
  }
  .bgd2{
    background-color: #d2d2d2;
  }
  .el-tabs__active-bar{ display:none;}
  .el-tabs__header{
    background: #f0f0f0;
    margin: 0;
    .el-tabs__item{
      height: 29px;
      line-height: 29px;
      padding: 0px;
      width: 159px;
      font-size: 18px;
      color: #999;
      text-align: center;
      background-color: #e5e5e5;
      &::before{
        content: "";
        position:absolute;
        left: -14px;
        top: 0px;
        width: 0;
        height: 0;
        border-top: 29px solid #e5e5e5;
        border-left: 14px solid transparent;
      }
      &::after{
        content: "";
        position:absolute;
        right: -14px;
        top: 0px;
        width: 0;
        height: 0;
        border-bottom: 29px solid #e5e5e5;
        border-right: 14px solid transparent;
      }
      &.is-active{
        color:#008cff;
        background: #fff;
        &::before{
          content: "";
          border-top: 29px solid #fff;
          border-left: 14px solid transparent;
        }
        &::after{
          content: "";
          border-bottom: 29px solid #fff;
          border-right: 14px solid transparent;
        }
      }
    }
  }
  .el-tabs .no-device {
    line-height: 136px;
    text-align: center;
    color: #cccccc;
  }
}
</style>






// WEBPACK FOOTER //
// src/components/ExpPage/CSceneManage/CDeviceComponent.vue